import { defineRouting } from "next-intl/routing";

// docs/i18n/ROLLBACK_I18N_SEO_VIDE_MAISON_BRUXELLES.md — French is the
// site's primary language and must live at the bare domain root (no /fr
// prefix, ever) for SEO: duplicate/competing URLs against the unprefixed
// legacy French pages otherwise dilute signals and confuse which URL Google
// selects as canonical. NL/EN keep their /nl, /en prefixes.
// `localeDetection: false`: no Accept-Language/cookie/geo-based automatic
// redirect on first visit — "/" must consistently serve French to every
// visitor and to Googlebot, never guess a different locale from headers.
export const routing = defineRouting({
  locales: ["fr", "nl", "en"],
  defaultLocale: "fr",
  localePrefix: "as-needed",
  localeDetection: false,
});
